import axios from 'axios'
import router from '@/router';

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
})

service.interceptors.request.use(config => {
    // 检查请求 URL 是否为特定的请求
    let token = sessionStorage.getItem('token');
    // config.headers['backtoken'] = token;
    // config.headers['usertoken'] = '1046791d1b55a2bd94968fe2bc3566b84240f0c59b5784e022ac7f638a340164';
    config.headers['YJS-TOKEN'] = `Bearer ${token}`;

    return config
}, err => {
    return Promise.reject(err)
})
service.interceptors.response.use(res => {
    return res.data
}, err => {
    router.push({name: 'downgrade'});
    return Promise.reject(err)
})

export default service
